module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_bottom_white-8c6327836cedff4035aa7d9f8a4876a0.svg";